export default {
  demo: 'Demo',
  button: 'Button Extension',
  modal: 'Draggable Modal',
  form: {
    demo: 'Form Demo',
    basic: 'Basic Form',
    rule: 'Rule Form',
    dynamic: 'Dynamic Form',
    customForm: 'Custom Form Component',
  },
  table: {
    demo: 'Table Demo',
    searchTable: 'Search Table',
    wzry: 'Honor of Kings',
    lol: 'League of Legends',
  },
  icon: 'Custom Icon',
};
